import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";

import Accordion from "../../accordion";
import { TaskDetail } from "./task-detail";
import CodingDetail from "./coding-detail";
import FinalQATaskDetail from "./final-qa-detail";

import { TaskType } from "shared/taskTypeMap";
import { getAppendedTaskLabel } from "../lib/constants";
import { convertToTimeZone } from "date-fns-timezone";
import { format } from "date-fns";
import { DATE_FNS_LONG_DATE_FORMAT, DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { taskTypeMessageKeyMap } from "../../../contexts/task/task";

const StatusItem = (props) => {
    const { icon, label, taskType, tasks, isComplete, isRedoEligible, showRedo } = props.task;
    const shipmentKey = tasks[0].context.shipmentKey || "";
    const shipmentProductKey = tasks[0].context.shipmentProductKey || "";
    const taskClass = classnames("task", { "-active": isComplete, "-current": props.isCurrentTask && !isComplete });
    const redoClass = classnames("button -small", { "-disabled": props.IsFinalized || !isRedoEligible || props.isBusy });

    const formatDueDate = (dueDate) => {
        const date = convertToTimeZone(dueDate, {
            timeZone: "America/Chicago",
        });

        return format(date, tasks[0].showTimeOnDueDate ? DATE_FNS_LONG_DATE_FORMAT : DATE_FNS_SHORT_DATE_FORMAT);
    };

    const dueDate =
        taskType !== taskTypeMessageKeyMap["measuring.standard"] && tasks[0] && tasks[0].taskDueOn ? (
            <p>
                <b>Due: {formatDueDate(tasks[0].taskDueOn)}</b>
            </p>
        ) : null;

    const taskData = tasks.map((task, i) => {
        const appendedLabel = getAppendedTaskLabel(task.taskType);
        var taskLabel = i === 0 ? `Current` : i === tasks.length - 1 ? "Original" : `Redo ${tasks.length - i - 1}`;

        if (appendedLabel) {
            taskLabel = `${taskLabel} - (${appendedLabel})`;
        }

        return (
            <TaskDetail
                key={task.key}
                task={task}
                label={taskLabel}
            />
        );
    });

    const taskDetail =
        taskType === "coding" ? (
            <CodingDetail tasks={tasks} />
        ) : !taskType.startsWith("finalqa") ? (
            <Accordion
                className="-no-indent"
                closeInactive={true}
            >
                {taskData}
            </Accordion>
        ) : (
            <FinalQATaskDetail
                task={tasks[0]}
                isCurrentTask={props.isCurrentTask}
            />
        );

    const hideMeasuringRedo = `${taskType}.standard` === TaskType.MEASURING && tasks[0].context.shipmentType === 2;

    return (
        <div className={taskClass}>
            <h3>
                <FontAwesomeIcon icon={icon} />
                {label}
            </h3>
            <div className="task-details">
                <div>
                    {showRedo && !props.isCurrentTask && !hideMeasuringRedo && (
                        <button
                            title="Redo"
                            aria-label={`Redo ${taskType}`}
                            className={redoClass}
                            disabled={props.disabled}
                            onClick={() => {
                                props.handleRedoClick(taskType, shipmentKey, shipmentProductKey, isRedoEligible);
                            }}
                        >
                            <FontAwesomeIcon icon={faRedo} />
                        </button>
                    )}
                    {dueDate}
                </div>

                {taskDetail}
            </div>
        </div>
    );
};

export default StatusItem;
